import "./sidebar-content.component.scss";

export const SidebarContentComponent = {
    template: require('./sidebar-content.component.html')
};